import React, { useState, useRef, useEffect } from 'react';
import { Overlay, Popover, Row, Col, Button } from 'react-bootstrap';
import { requestNotificationPermission } from '../../../utils/firebase';

function NotificationPopover(props) {
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const [hidePermissions, setHidePermissions] = useState('');

    const setParentNotifications = () => {
        props.setNotifications(true);
    }

    const handleHidePermissions = () => {
        // User said no, respect that for this session
        setShow(false);
        try {
            sessionStorage.setItem('hidePermissions', true);
        } catch (error) {
            console.warn('Unable to access sessionStorage:', error);
        }
    }

    useEffect(() => {
        setShow(false);
        
        // Retrieve the session variable
        const hidePermissionsState = sessionStorage.getItem('hidePermissions');
        setHidePermissions(hidePermissionsState);
        
        if (props.notificationsEnabled === false && !hidePermissionsState) {
            setShow(true);
        }
    }, [props.notificationsEnabled]);

    return (
        <>
            <div ref={target}></div>

            <Overlay
                show={show}
                target={target.current}
                placement="bottom"
                
                containerPadding={20} // Optional: if you want padding around the edges in the container
            >
                {(props) => (
                    <Popover id="test-popover" style={{ position: "fixed", top: "20px", left: "20px"}}>
                        <Popover.Body>
                            <Row className="align-items-center">
                                <Col xl="2"><img src="https://zoombies.world/images/bonez/bonez_logo_192x192.png" style={{ maxWidth: "36px" }} /></Col>
                                <Col>
                                    <h3>Subscribe to notifications</h3>
                                    <p style={{ fontSize: "1.3rem" }}>Receive friend requests and accepts, game invites, bones notices from friends</p>
                                    <Button variant="primary" onClick={() => {requestNotificationPermission(true); setShow(false); setParentNotifications(true)}}>Allow</Button> &nbsp;
                                    <Button variant="secondary" onClick={() => handleHidePermissions()}>Don't Allow</Button>
                                </Col>
                            </Row>
                        </Popover.Body>
                    </Popover>
                )}
            </Overlay>
        </>
    );
}

export default NotificationPopover;